import Enumerable from "linq";
import { IClipboardWatchable, IClipboardItem } from "../../domain/system";

export class ClipboardWatcher<T> implements IClipboardWatchable<T> {
  constructor(
    private readonly _reader: (count: number, latestSequenceNo: number) => Promise<IClipboardItem<T>[]>,
    private readonly _intervalAsMsec: number = 0,
    private readonly _clear: () => void = () => {},
    private readonly _remove: (sequenceNo: number) => void = () => {},
  ) {
  }

  private _instance = null as IInstance<T>;
  private _latestSequenceNo: number = 0;

  register(count: number, handler: (values: IClipboardItem<T>[]) => void): void {
    this._instance = (!count || (count <= 0) || !handler)
      ? null
      : {
        count,
        handler,
        items: [],
      };
    this.poll();
    if (0 < this._intervalAsMsec) {
      setInterval(() => this.poll(), this._intervalAsMsec);
    }
  }

  clear(): void {
    this._clear();
    this._instance.items = [];
    this._latestSequenceNo = 0;
    this._instance.handler(this._instance.items);
  }

  remove(item: IClipboardItem<T>) {
    this._remove(item.sequenceNo);
    this._instance.items = Enumerable.from(this._instance.items).where(x => x !== item).toArray();
    this._latestSequenceNo = this.getLatestSequenceNo();
    this._instance.handler(this._instance.items);
  }

  poll(): void {
    this._reader(this._instance.count, this._latestSequenceNo)
      .then(i => {
        if (!i || (i.length <= 0)) {
          return;
        }
        this._instance.items = Enumerable.from(this._instance.items)
          .concat(i)
          .skip(this._instance.items.length + i.length - this._instance.count)
          .toArray();
        this._latestSequenceNo = this.getLatestSequenceNo();
        this._instance.handler(this._instance.items);
      })
      .catch(e => {
        console.error("clipboard情報取得できませんでした.");
        console.error(e);
      });
  }

  private getLatestSequenceNo(): number {
    return Enumerable.from(this._instance.items)
      .select(i => i.sequenceNo)
      .concat(0)
      .max(s => s);
  }
}

interface IInstance<T> {
  count: number;
  handler: (values: IClipboardItem<T>[]) => void;
  items: IClipboardItem<T>[];  
}
